/* Company Confidential, Copyright (c) 2017 CRF Box, Ltd. All Rights Reserved. */

export const MODAL_TYPE_SPONSORS = 'MODAL_TYPE_SPONSORS';
export const MODAL_TYPE_CONFIRMATION = 'MODAL_TYPE_CONFIRMATION';
export const MODAL_TYPE_HELPDESK = 'MODAL_TYPE_HELPDESK';
export const MODAL_TYPE_EDIT_PARTICIPANT_STATUS = 'MODAL_TYPE_EDIT_PARTICIPANT_STATUS';
export const MODAL_TYPE_EDIT_PARTICIPANT_DETAILS = 'MODAL_TYPE_EDIT_PARTICIPANT_DETAILS';
export const MODAL_TYPE_EDIT_PARTICIPANT_GENDER = 'MODAL_TYPE_EDIT_PARTICIPANT_GENDER';
export const MODAL_TYPE_EDIT_PARTICIPANT_BIRTHDATE = 'MODAL_TYPE_EDIT_PARTICIPANT_BIRTHDATE';
export const MODAL_TYPE_EDIT_PARTICIPANT_ADDRESS = 'MODAL_TYPE_EDIT_PARTICIPANT_ADDRESS';
export const MODAL_TYPE_EDIT_DOCUMENT_STATUS = 'MODAL_TYPE_EDIT_DOCUMENT_STATUS';
export const MODAL_TYPE_EDIT_DOCUMENT_STATUS_OPT_INOUT = 'MODAL_TYPE_EDIT_DOCUMENT_STATUS_OPT_INOUT';
export const MODAL_TYPE_ADD_NOTE = 'MODAL_TYPE_ADD_NOTE';
export const MODAL_TYPE_PDF_MODAL = 'MODAL_TYPE_PDF_MODAL';
export const MODAL_TYPE_ALL_SITES_REPORTS = 'MODAL_TYPE_ALL_SITES_REPORTS';
export const MODAL_TYPE_PARTICIPANT_ARCHIVE = 'MODAL_TYPE_PARTICIPANT_ARCHIVE';
export const MODAL_TYPE_PARTICIPANT_ARCHIVE_EXPORT = 'MODAL_TYPE_PARTICIPANT_ARCHIVE_EXPORT';
export const MODAL_TYPE_ARCHIVE_EXPORT_CONFIRMATION = 'MODAL_TYPE_ARCHIVE_EXPORT_CONFIRMATION';
export const MODAL_TYPE_FLAG = 'MODAL_TYPE_FLAG';
export const MODAL_TYPE_WAITING = 'MODAL_TYPE_WAITING';
export const MODAL_TYPE_DELETE_PDF = 'MODAL_TYPE_DELETE_PDF';
export const MODAL_TYPE_DELETE_ADDENDUM = 'MODAL_TYPE_DELETE_ADDENDU';
export const MODAL_TYPE_ADD_NEW_PARTICIPANT_DOCUMENT = 'MODAL_TYPE_ADD_NEW_PARTICIPANT_DOCUMENT';
export const MODAL_TYPE_PARTICIPANT_HAS_NEW_VERSIONS = 'MODAL_TYPE_PARTICIPANT_HAS_NEW_VERSIONS';
export const MODAL_TYPE_EDIT_PARTICIPANT_EMAIL = 'MODAL_TYPE_EDIT_PARTICIPANT_EMAIL';
export const MODAL_TYPE_REMOVE_OBJECT_ID = 'MODAL_TYPE_REMOVE_OBJECT_ID';
export const MODAL_TYPE_UPDATE_OBJECT_ID = 'MODAL_TYPE_UPDATE_OBJECT_ID';

export const MODAL_TYPE_CHANGE_ANSWERS = 'MODAL_TYPE_CHANGE_ANSWERS';
export const MODAL_TYPE_CHANGE_ANSWERS_OPTIN_OPTOUT = 'MODAL_TYPE_CHANGE_ANSWERS_OPTIN_OPTOUT';
export const MODAL_TYPE_CHANGE_ANSWERS_ADDENDUM = 'MODAL_TYPE_CHANGE_ANSWERS_ADDENDUM';
